<template>
  <div>
    <BlNavBarMv :title="categoryName" has-back-button style="border-bottom: 1px solid #ebebeb" @handleBackButtonClick="toPreviousPage" />

    <BlBreadcrumbAv class="mt-12 ph-16" :breadcrumb-lists="breadcrumbItems" />

    <BlEmptyStateMv
      v-if="isError.courses"
      type="full"
      title="Kelas gagal dimuat, silakan coba lagi"
      main-button-text="Muat ulang"
      alt-image="Kelas gagal dimuat, silakan coba lagi"
      class="error-full-height qa-error-courses"
      @mainButtonClick="fetchCourses"
    />

    <BlEmptyStateMv
      v-else-if="!isAppLoading && !courses.length"
      type="full"
      title="Kelas yang kamu cari tidak ditemukan"
      main-button-text="Kembali"
      alt-image="Kelas yang kamu cari tidak ditemukan"
      class="error-full-height qa-no-courses"
      @mainButtonClick="toPreviousPage"
    />

    <template v-else>
      <BlTextAv tag="h1" class="pt-16 pl-16" variation="caption-12">Pelatihan {{ categoryName }} Prakerja</BlTextAv>
      <BlFlexContainerMv v-if="isAppLoading && !courses.length" padding="12px 16px" class="qa-prakerja-card-shimmer">
        <PrakerjaCardShimmer :count="8" />
      </BlFlexContainerMv>
      <div v-else class="grid grid-cols-2 gap-3 mh-16 mt-12">
        <BlFlexItemAv v-for="course in courses" :key="course.id" grow="1" basis="1" class="prakerja-card-wrapper qa-prakerja-course">
          <PrakerjaCard :course="course" />
        </BlFlexItemAv>
      </div>
      <!-- shimmer infiniteScroll -->
      <BlFlexContainerMv v-if="isAppLoading && courses.length" grow="1" basis="1" class="qa-prakerja-card-shimmer">
        <PrakerjaCardShimmer :count="4" />
      </BlFlexContainerMv>
      <!-- shimmer infiniteScroll End -->
    </template>

    <div
      v-infinite-scroll="fetchCourses"
      :infinite-scroll-disabled="isAllCoursesLoaded"
      :infinite-scroll-distance="500"
      class="w-full"
      style="height: 20px"
    ></div>

    <BlSeparatorAv :height="12" />

    <PrakerjaCategoryAbout />
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {BlNavBarMv, BlEmptyStateMv, BlSeparatorAv} from '@bukalapak/bazaar-mweb-latest';
import BlBreadcrumbAv from 'shared/components/BlBreadcrumbAv';
import infiniteScroll from 'vue-infinite-scroll';

import PrakerjaCardShimmer from '../components/PrakerjaCardShimmer/PrakerjaCardShimmer.vue';
import PrakerjaCategoryAbout from '../components/PrakerjaCategoryPage/PrakerjaCategoryAbout.vue';

import PrakerjaCard from '../components/PrakerjaCard/PrakerjaCard.vue';
import trackerGenerator from '../mixins/tracker-generator';
import {TRACKER_EVENT_VP_PRAKERJA_CATEGORY} from '../config/tracker-events';

export default {
  name: 'PrakerjaCategoryDetailPage',
  directives: {infiniteScroll},

  components: {
    BlNavBarMv,
    PrakerjaCard,
    PrakerjaCardShimmer,
    BlEmptyStateMv,
    PrakerjaCategoryAbout,
    BlSeparatorAv,
    BlBreadcrumbAv,
  },
  mixins: [trackerGenerator],
  computed: {
    ...mapGetters(['isAppLoading']),
    ...mapGetters({
      isError: 'getError',
      courses: 'courses/getCourses',
      isAllCoursesLoaded: 'courses/getIsAllCoursesLoaded',
      categoriesConfig: 'categories/getCategoriesConfig',
    }),
    categoryId() {
      return this.$route.params.id;
    },
    categoryName() {
      const foundCategory = this.categoriesConfig.find((category) => category.id === Number(this.categoryId));
      return foundCategory?.name;
    },
    breadcrumbItems() {
      return [
        {
          name: 'Beranda',
          url: process.env.BASE_PATH,
        },
        {
          name: this.categoryName,
          url: '#',
        },
      ];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      window.scrollTo(0, 0);
      await this.$store.dispatch('categories/fetchCategoriesConfig');
      this.$store.commit('courses/resetCourses');

      await this.fetchCourses();
      this.trackPrakerjaCategory();
    },
    toPreviousPage() {
      this.$router.go(-1);
    },
    fetchCourses() {
      this.$store.commit('categories/setSelectedCategory', this.categoryId);
      return this.$store.dispatch('courses/fetchCourses');
    },
    trackPrakerjaCategory() {
      const payload = {
        source: 'new-category-section',
        category: this.categoryName,
        any_result: !!this.courses.length,
      };
      return this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_CATEGORY, payload);
    },
  },
};
</script>

<style scoped>
.error-full-height {
  height: calc(100vh - 56px) !important;
}
</style>
